<div class="container">
    <h3>{{headerText | translate}}</h3>
    <div class="devices row">
        <div class="device col-12 col-md-6 col-lg-3"
             *ngFor="let device of devices"
             (click)="selectDevice(device)"
             [ngClass]="{selected : selectedDeviceID === device.id}">
            <div class="tick">
                <img [src]="imgUrl + 'tick.png'">
            </div>
            <div class="image text-center">
                <img [src]="imgUrl + device.id + '.png'">
            </div>
            <div class="name">
                {{device.name}}
            </div>
        </div>
    </div>


    <div (click)="backToPrevStep()" class="jumper"><img class="mr-1" [src]="imgUrl + 'svg/back_arrow.svg'" />{{'Previous Step' | translate}}</div>

</div>
